import baseApi, {
    transformResponseFromData,
    provideTag,
} from 'store/slices/api/baseApi'
import {constructUrl} from './utils'

const publicationFoldersApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPublicationFolders: build.query({
            query: (query) => {
                const url = constructUrl('publicationFolders', {
                    ...query,
                    sort: query.sort ?? JSON.stringify({created: 'desc'}),
                })
                return {
                    url,
                    method: 'GET',
                }
            },
            transformResponse: transformResponseFromData,
            providesTags: () => provideTag('PublicationFolder'),
        }),
        getPublicationFolder: build.query({
            query: (id) => ({
                url: `publicationFolders/${id}`,
                method: 'GET',
            }),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTag('PublicationFolder', result),
        }),
        createPublicationFolder: build.mutation({
            query: (body) => {
                return {
                    url: `publicationFolders`,
                    method: 'POST',
                    body,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('PublicationFolder'),
        }),
        savePublicationFolder: build.mutation({
            query: (body) => {
                return {
                    url: `publicationFolders/${body._id}`,
                    method: 'PUT',
                    body,
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: (result) =>
                provideTag('PublicationFolder', result),
        }),
        deletePublicationFolder: build.mutation({
            query: (id) => {
                return {
                    url: `publicationFolders/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: transformResponseFromData,
            invalidatesTags: () => provideTag('PublicationFolder'),
        }),
    }),
    overrideExisting: false,
})

export default publicationFoldersApi

export const {
    useGetPublicationFoldersQuery,
    useGetPublicationFolderQuery,
    useDeletePublicationFolderMutation,
    useSavePublicationFolderMutation,
    useCreatePublicationFolderMutation,
} = publicationFoldersApi
